import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const NotFoundPage = () => (
  <div className="min-h-screen bg-ink-950" data-testid="not-found-page">
    <Header />
    <main className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-40 text-center">
      <span className="text-[11px] tracking-[0.3em] uppercase text-champagne font-body">
        404
      </span>
      <h1 className="font-display text-5xl md:text-7xl text-white mt-4 tracking-tight">
        Pagina niet gevonden
      </h1>
      <p className="mt-6 text-sm text-zinc-400 font-body max-w-md mx-auto">
        De door u opgevraagde pagina bestaat niet of is verplaatst.
      </p>
      <Link
        to="/aanbod"
        className="inline-block mt-10 px-8 py-4 bg-champagne text-ink-950 hover:bg-champagne-soft transition-colors text-[11px] tracking-[0.3em] uppercase font-body font-semibold"
      >
        Naar het aanbod
      </Link>
    </main>
    <Footer />
  </div>
);

export default NotFoundPage;
